<template>
  <div>
    <div
      v-if="
              (isExecCustom || ['102', '111', '113'].includes(execTypeSub)) && tradeApplyOrderPocCheckInfo
            "
      class="trade-order-block"
    >
      <div class="block-title">
        选店标准 {{tradeApplyOrderPocCheckInfo}}
        <span class="standard-title" @click="completeStandardDialog = true">
          <img src="@/assets/images/doubt.png" alt />
        </span>
      </div>
      <table v-for="(itemList, key) in tradeApplyOrderPocCheckInfo" :key="key" class="investment-table">
        <th :class="checkStandardAll(itemList) ? 'isMeet' : 'Meet'">
          {{ key }}
          <i v-if="checkStandardAll(itemList)">
            <img src="@/assets/images/conformity.png" alt />
          </i>
          <i v-else>
            <img src="@/assets/images/no-conformity.png" alt />
          </i>
        </th>
        <th>地理位置</th>
        <th>门店特征</th>
        <th>人均消费</th>
        <tr>
          <td>选店标准</td>
          <td v-for="(item, index) in itemList" :key="index">{{ item.checkStandard }}</td>
        </tr>
        <tr>
          <td>当前门店</td>
          <td v-for="(item, index) in itemList" :key="index" :class="item.isMatch ? '' : 'Meet'">{{ item.pocValue }}</td>
        </tr>
      </table>
    </div>
    <el-dialog
      :visible.sync="completeStandardDialog"
      :close-on-click-modal="false"
      width="900px"
      :title="
              ['102', '111', '113'].includes(execTypeSub)
                ? '资产冰柜完整标准'
                : '门店定制完整标准'
            "
    >
      <div class="complete-standard-info">
        <img
          v-if="
                  ['102', '111', '113'].includes(execTypeSub)
                "
          src="@/assets/images/cooler-standard.png"
          alt
        />
        <img v-else src="@/assets/images/store-standard.png" alt />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    execTypeSub: {
      type: String,
      default: ''
    },
    tradeApplyOrderPocCheckInfo: {
      type: Object,
      default: () => {
        return null
      }
    },
    isExecCustom: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      completeStandardDialog: false
    }
  },
  computed: {

  },
  methods: {
    // 判断门店是否符合所有标准
    checkStandardAll (list) {
      return list.every((item) => {
        return item.isMatch === 1
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.standard-title {
  font-size: 0px;
  color: #cacbca;
  cursor: pointer;
  width: 14px;
  height: 14px;
  display: inline-block;
  line-height: 18px;
  img {
    width: 100%;
  }
}
.investment-table {
  width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  margin-top: 30px;
  border-collapse: collapse;
  line-height: 23px;
  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    img {
      width: 100%;
    }
  }
  th {
    padding: 12px 0;
    background: #f5f7fa;
    color: rgb(56, 55, 55);
  }
  td {
    // width: 130px;
    text-align: center;
    border: 1px solid #ebeef5;
    padding: 12px 0;
    box-sizing: border-box;
    color: #606266;
    &:nth-child(1) {
      width: 205px;
    }
    &:nth-child(2) {
      width: 400px;
    }
    &:nth-child(3) {
      width: 400px;
    }
    &:nth-child(2) {
      width: 400px;
    }
  }
  .isMeet {
    color: #3faa1d;
  }
  .Meet {
    color: #f29613;
  }
}
</style>